import React from "react";
import { Grid, InputAdornment, TextField, Typography } from "@mui/material";
import { AttachMoney as MoneyIcon, BadgeOutlined as BadgeIcon } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

interface ContactKycSectionProps {
  kyc: {
    dob: any;
    employmentStatus: string;
    annualIncome: string;
    targetRetirementAge: string;
    idDocType: string;
  };
  onChange: (field: string, value: any) => void;
}

const sectionTitleStyle = {
  fontWeight: "bold",
  color: "primary.main",
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
} as const;

const ContactKycSection: React.FC<ContactKycSectionProps> = ({ kyc, onChange }) => (
  <>
    <Typography variant="subtitle1" sx={sectionTitleStyle}>
      <MoneyIcon fontSize="small" /> Financial Suitability (KYC)
    </Typography>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DatePicker
            label="Date of Birth (DOB)"
            value={kyc.dob}
            onChange={(val) => onChange("dob", val)}
            format="DD/MM/YYYY"
            maxDate={dayjs()}
            disableFuture
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                sx: { bgcolor: "background.paper" },
                placeholder: "DD/MM/YYYY",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Employment Status"
            fullWidth
            size="small"
            sx={{ bgcolor: "background.paper" }}
            value={kyc.employmentStatus}
            onChange={(e) => onChange("employmentStatus", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Annual Income"
            placeholder="e.g., 85000"
            fullWidth
            size="small"
            sx={{ bgcolor: "background.paper" }}
            value={kyc.annualIncome}
            onChange={(e) => onChange("annualIncome", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Target Retirement Age"
            placeholder="e.g., 65"
            type="number"
            fullWidth
            size="small"
            sx={{ bgcolor: "background.paper" }}
            value={kyc.targetRetirementAge}
            onChange={(e) => onChange("targetRetirementAge", e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="ID Document Type"
            placeholder="e.g., Passport, Driver's License"
            fullWidth
            size="small"
            sx={{ bgcolor: "background.paper" }}
            value={kyc.idDocType}
            onChange={(e) => onChange("idDocType", e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BadgeIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  </>
);

export default ContactKycSection;
